import React, { Fragment } from 'react'
import { SignIn } from 'aws-amplify-react'
import { Auth } from 'aws-amplify'
import { Text } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import style from './auth.module.scss'
import AuthContainer from './AuthContainer'
import { withTranslation } from 'react-i18next'
import { checkAccess } from './utils'

class MySignIn extends SignIn {
	state = {
		isSubmitting: false
	}

	setSubmitState = val => this.setState({ isSubmitting: val })

	getApi = formApi => {
		this.formApi = formApi
	}

	signIn = async ({ username = '', password }) => {
		if(this.state.isSubmitting) {
			return
		}
		const { t } = this.props

		this.setSubmitState(true)
		try {
			const user = await Auth.signIn(username.toLowerCase(), password)
			const hasAccess = checkAccess(user)
			if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
				this.changeState('confirmSignIn', user)
			} else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
				this.changeState('requireNewPassword', user)
			} else if(!hasAccess) {
				this.formApi.setError('username', t('auth_screen.error.no_access'))
				Auth.signOut()
			} else {
				this.checkContact(user)
			}
		} catch(err) {
			if(err.code === 'UserNotFoundException' || err.code === 'InvalidParameterException') {
				this.formApi.setError('username', t('auth_screen.error.user_not_found'))
			} else if(err.code === 'NotAuthorizedException') {
				switch(err.message) {
					case 'User is disabled':
						this.formApi.setError('username', t('auth_screen.error.user_disabled'))
						break
					case 'Incorrect username or password.':
						this.formApi.setError('password', t('auth_screen.error.incorrect_password'))
						break
					default:
						this.formApi.setError('username', t('auth_screen.error.not_authorized'))
						break
				}
			} else if(err.code === 'NetworkError') {
				this.formApi.setError('username', t('auth_screen.error.network'))
			} else {
				console.error(err)
				this.formApi.setError('username', t('auth_screen.error.unknown'))
			}
		} finally {
			this.setSubmitState(false)
		}
	}

	showComponent(theme, { changeState, authState, t } = this.props) {
		return(
			<AuthContainer getApi={this.getApi} className={style.form} onSubmit={this.signIn}>
				{({ formState: { values, errors } }) => (
					<Fragment>
						<p>{t('auth_screen.message.auth')}</p>
						<Divider height={20}/>
						<Text
							errors={errors}
							errorClass={style.formInputError}
							validate={v => (v ? null : t('auth_screen.error.login_required'))}
							validateOnChange
							type='text'
							field='username'
							placeholder={t('auth_screen.form.login')}
							usePlaceholder
						/>
						<Text
							errors={errors}
							errorClass={style.formInputError}
							validate={v => (v ? null : t('auth_screen.error.password_required'))}
							validateOnChange
							type='password'
							field='password'
							placeholder={t('auth_screen.form.password')}
							usePlaceholder
						/>
						<Button
							status='active'
							text={t('auth_screen.button.login')}
							type='submit'
							{...this.state.isSubmitting && { loading: true }}
						/>
						<div className={style.linkButton} onClick={() => this.changeState('forgotPassword')}>
							{t('auth_screen.button.forgot_password')}
						</div>
					</Fragment>
				)}
			</AuthContainer>
		)
	}
}

export default withTranslation()(MySignIn)
